/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react"
import Content from "../../../../../layout/content/Content"
import { Doughnut } from "react-chartjs-2"
import {
    Button,
    Block,
    BlockDes,
    BlockHead,
    Icon,
    Col,
    Row,
    PreviewAltCard,
} from "../../../../../components/Component"
import Head from "../../../../../layout/head/Head"
import CpDashdataUpdate from "./CpDashdataUpdate"
import FinancialYear from "../../../../components/DynmicOption/FinancialYear"
import SingleQuater from "../../../../components/DynmicOption/singlequarter";

const CPDashboard = () => {

    const [selectedYear, setSelectedYear] = useState("")
    const [userData, setuserData] = useState(null)
    const [Edit, setEdit] = useState({
        edit: 0,
        submit: 0,
        open: 0
    })
    const [Selected, setSelected] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([])
    const [data2, setdata2] = useState({
        labels: ["Deaft", "Submitted", "Open"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                data: [2, 2, 2],
            },
        ],
    })
    const tableRef = useRef(null)

    const Getdata2 = async () => {
        

            const sendData = {
                UserId: Number(localStorage.getItem("userId")),
                MonthId: Number(selectedOptions.value),
                EmploymentRefCpId: Number(13),
                YearId: Number(selectedYear),
            }
           // console.log("SendData", sendData)
            await fetch(process.env.REACT_APP_API_LINK + 'api/CP/DashdatacountCP', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                       // console.log(data)
                        setEdit({
                            edit: data.edit,
                            submit: data.submit,
                            open: data.open
                        })
                        setdata2({
                            labels: ["Draft", "Submitted", "Open"],
                            dataUnit: "People",
                            legend: false,
                            datasets: [
                                {
                                    borderColor: "#fff",
                                    backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                                    data: [data.edit, data.submit, data.open],
                                },
                            ],
                        })
                    })
        

    };

    const Usergetdata = async () => {


        const sendData = {
            UserId: Number(localStorage.getItem("userId")),

        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setuserData(data)

                })


    }
    
    useEffect(() => {
        Usergetdata()
    }, [])


    useEffect(() => {
        Getdata2()
    }, [selectedOptions, selectedYear])
    return (
        <React.Fragment>
            <Head title="AllUser" />

            <Content>
                {localStorage.getItem("urole") !== "16" ?
                    <Button onClick={() => window.location.href = '/CPRegionaldashboard'} style={{ marginBottom: 20 }} color='success'> <Icon name="arrow-left" />  Back To CP Regional Dashboard</Button> : null}

                <Block>

                    <BlockHead size="lg">

                        <BlockDes className="text-soft">

                            <Row >

                                <Col xl="2" md="2">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>CP1 Dashboard</h5>
                                    </td>
                                </Col> <Col xl="3" md="3">
                                    <td >
                                        <label style={{ color: 'black', fontSize: 15 }}>  Exchange :  <label style={{ fontWeight: 'bold' }}>{userData != null ? userData.answer1 : null}</label></label>
                                    </td>
                                </Col>
                                <Col xl="2" md="2" >

                                    <label style={{ color: 'black', fontSize: 15 }}>  Center :  <label style={{ fontWeight: 'bold' }}> {userData != null ? userData.state : null}</label></label>
                                </Col>
                                <Col xl="2" md="2" >
                                    <label style={{ color: 'black', fontSize: 15 }}>  Year :  <label style={{ fontWeight: 'bold' }}><FinancialYear selectedYear={selectedYear} setSelectedYear={setSelectedYear} /></label></label>


                                </Col>
                               {/* <Col xl="2" md="2" >
                                    <select
                                        className="form-control form-select"
                                        name="Quarter"
                                        onChange={(e) => onInputChangeQuater(e)}
                                    >
                                        <option value="none" hidden selected disabled>{sessionStorage.getItem("CurrentMonthCP") === null ? "Select" : month1[sessionStorage.getItem("CurrentMonthCP")]}</option>
                                       
                                        <option value="4" > Quarter 1 (Apr- Jun)</option>
                                        <option value="7" > Quarter 2 (Jul- Sep)</option>
                                        <option value="10" > Quarter 3 (Oct- Dec)</option>
                                        <option value="1" > Quarter 4 (Jan- Mar)</option>
                                       
                                    </select>


                                </Col>*/}
                                <Col xl="2" md="2">
                                    <label style={{ color: 'black' }} >   <label style={{ fontWeight: 'bold' }}> <SingleQuater setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} setSelected={setSelected} Selected={Selected} /></label></label>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col md="4" xxl="4">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The user dashboard shows the data of employment exchange of a particular month

                                        </small></h6>
                                    </PreviewAltCard>
                                </Col>
                                <Col md="8" xxl="8">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <Row>
                                            <Col md="2"></Col>
                                            <Col md="6">
                                                <div className="traffic-channel-group">

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                            <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {Edit.edit}</large> </b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                            <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}> {Edit.submit}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>
                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                                                            <b style={{ fontSize: 20 }}> Open  : <large style={{ marginLeft: 77 }}> {Edit.open}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="traffic-channel-doughnut-ck">
                                                    <Doughnut
                                                        className="analytics-doughnut"
                                                        data={data2}
                                                        options={{
                                                            legend: {
                                                                display: false,
                                                            },
                                                            rotation: -1.5,
                                                            cutoutPercentage: 70,
                                                            maintainAspectRatio: false,
                                                            tooltips: {
                                                                enabled: true,
                                                                backgroundColor: "#fff",
                                                                borderColor: "#eff6ff",
                                                                borderWidth: 2,
                                                                titleFontSize: 13,
                                                                titleFontColor: "#6783b8",
                                                                titleMarginBottom: 6,
                                                                bodyFontColor: "#9eaecf",
                                                                bodyFontSize: 12,
                                                                bodySpacing: 4,
                                                                yPadding: 10,
                                                                xPadding: 10,
                                                                footerMarginTop: 0,
                                                                displayColors: false,
                                                            },
                                                        }}
                                                    ></Doughnut>
                                                </div>

                                            </Col>
                                        </Row>
                                    </PreviewAltCard>

                                </Col>
                            </Row>
                        </BlockDes>


                    </BlockHead>


                    <div className="table-responsive">
                        <table className="table table-orders" ref={tableRef}>
                            <thead className="tb-odr-head">

                                <tr className="tb-odr-item" style={{ textAlign: 'center' }}>
                                    <th >
                                        S.No

                                    </th>
                                    <th >
                                        Form Name

                                    </th>
                                    <th  >
                                        Status

                                    </th>
                                    <th >
                                        Action

                                    </th>
                                    {localStorage.getItem("urole") === "16" && (
                                        <th>
                                            Request Edit

                                        </th> 
                                    )}
                                </tr>


                            </thead>
                                    <>
                                <tbody>
                                    {(selectedOptions.value !== 0 || sessionStorage.getItem("CurrentMonthCP") !== null) && Number(selectedYear) !== 0 ? <tr className="tb-odr-item" style={{ textAlign: 'center' }}>

                                       <td>
                                            <a
                                                href="#id"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                            >
                                                <b style={{ fontSize: 18 }}>1</b>
                                            </a>
                                        </td>
                                        <td  >
                                            <a
                                                href="#id"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                            >
                                                <b style={{ fontSize: 18 }}>CP1</b>
                                            </a>
                                        </td>
                                        <CpDashdataUpdate month={selectedOptions.value} year={selectedYear} CpDashdataUpdate={CpDashdataUpdate} />
                                    </tr> : <tr><td colSpan="4"><h4 className="m-2"> Please Select A Year and Quarter to Generate Data </h4></td></tr>}
                                        </tbody>
                                    </>
                                

                        </table>

                    </div>




                </Block>




            </Content>

        </React.Fragment>
    );
};

export default CPDashboard;
